import React from 'react'
import PropTypes from 'prop-types'

import localization from '../../localization/thehouse'

import styles from './FeaturesBlock.module.styl'

const FeaturesBlock = (props) => {
  const { language } = props

  return (
    <section className={styles.featuresBlock}>
      <div className={[styles.category, styles.general].join(' ')}>
        <h2 className="t-heading-xs">{localization[language].featuresItems1Title}</h2>
        <ul>{localization[language].featuresItems1.map(item => <li key={item}>{item}</li>)}</ul>
      </div>

      <div className={[styles.category, styles.recreation].join(' ')}>
        <h2 className="t-heading-xs">{localization[language].featuresItems2Title}</h2>
        <ul>{localization[language].featuresItems2.map(item => <li key={item}>{item}</li>)}</ul>
      </div>

      <div className={[styles.category, styles.domestic].join(' ')}>
        <h2 className="t-heading-xs">{localization[language].featuresItems3Title}</h2>
        <ul>{localization[language].featuresItems3.map(item => <li key={item}>{item}</li>)}</ul>
      </div>

      <div className={[styles.category, styles.facilities].join(' ')}>
        <h2 className="t-heading-xs">{localization[language].featuresItems4Title}</h2>
        <ul>{localization[language].featuresItems4.map(item => <li key={item}>{item}</li>)}</ul>
      </div>
    </section>
  )
}

FeaturesBlock.propTypes = {
  language: PropTypes.string.isRequired,
}

FeaturesBlock.defaultProps = {
  
}

export default FeaturesBlock



// WEBPACK FOOTER //
// ./src/components/FeaturesBlock/FeaturesBlock.js